import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import DropzoneWrapperSC, { FileThumbSC } from './identity-dropzone.styled';
import { ReactComponent as CloudIcon } from '../../../../assets/img/svg/upload-cloud.svg';
import { ReactComponent as CheckIcon } from '../../../../assets/img/svg/check-circle-doc.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/img/svg/x-circle.svg';
import { ReactComponent as PdfIcon } from '../../../../assets/img/svg/pdf.svg';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../../utils/default-lang';
import { IdentityFormErrorSC } from '../identity-form.styled';
import { SmallText } from '../../../typography';

function IdentityDropzone(props) {
  const [files, setFiles] = useState([]);
  const [isDragOver, setDragOver] = useState(false);
  const [fileAdded, setFileAdded] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [equalError, setEqualError] = useState(false);
  const { setSelectedFile } = props;
  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    accept: ['image/jpeg', 'image/png', 'application/pdf'],
    maxSize: 10000000,
    onDragEnter: () => {
      setDragOver(true);
    },
    onDropRejected: (rejectedFiles) => {
      if (rejectedFiles && rejectedFiles[0].file.size > 10000000) {
        setSelectedFile(['']);
        setFiles(['']);
        setSizeError(true);
        setFileAdded(false);
      }
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles[0]) {
        const match = props.allFiles.find((file) => {
          return (
            file.name === acceptedFiles[0].name &&
            file?.lastModified === acceptedFiles[0]?.lastModified &&
            file?.size === acceptedFiles[0]?.size
          );
        });
        if (match) {
          setSelectedFile(['']);
          setFiles(['']);
          setFileAdded(false);
          setEqualError(true);
          return null;
        }
      }
      setEqualError(false);
      setSizeError(false);
      setDragOver(false);
      setFileAdded(true);
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      setSelectedFile(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const clearFile = () => {
    setSelectedFile(['']);
    setFiles(['']);
    setFileAdded(false);
  };

  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  return (
    <>
      {files[0] ? null : (
        <DropzoneWrapperSC
          {...getRootProps({ isDragActive, isDragAccept, isDragReject })}
          className={
            isDragOver ? 'active' : props.hasError ? 'error' : fileAdded ? 'success' : null
          }
        >
          <input
            name={props.name}
            onChange={props.onChange}
            onBlur={props.onBlur}
            {...getInputProps()}
          />
          <span>
            {fileAdded ? (
              <>
                <CheckIcon />
                {files[0] ? files[0].name : null}
              </>
            ) : (
              <>
                <CloudIcon />
                <FormattedMessage
                  id={`onboarding_identity_documents_form_upload_${props.side}_document`}
                  defaultMessage={
                    dlt[`onboarding_identity_documents_form_upload_${props.side}_document`]
                  }
                />
              </>
            )}
          </span>
        </DropzoneWrapperSC>
      )}

      {files[0] ? (
        <>
          <FileThumbSC>
            {files[0].type === 'application/pdf' ? (
              <div className="image-wrap pdf">
                <PdfIcon />
              </div>
            ) : (
              <div className="image-wrap">
                <img src={files[0].preview} alt="" />
              </div>
            )}

            <div className="action-wrap">
              <button onClick={() => clearFile()}>
                <SmallText className="red bold">
                  <FormattedMessage id="global_delete" defaultMessage={dlt['global_delete']} />
                </SmallText>
                <DeleteIcon />
              </button>
            </div>
          </FileThumbSC>
          <SmallText className="smaller">{files[0].name}</SmallText>
        </>
      ) : null}

      {sizeError ? (
        <IdentityFormErrorSC>
          <FormattedMessage
            id="onboarding_identity_documents_form_upload_size_error"
            defaultMessage={dlt['onboarding_identity_documents_form_upload_size_error']}
          />
        </IdentityFormErrorSC>
      ) : equalError ? (
        <IdentityFormErrorSC>
          <FormattedMessage
            id="onboarding_identity_documents_form_upload_equal_error"
            defaultMessage={dlt['onboarding_identity_documents_form_upload_equal_error']}
          />
        </IdentityFormErrorSC>
      ) : null}
    </>
  );
}

export default IdentityDropzone;
